import Superadmin from './super_admin.js'
import Globaladmin from './global_admin.js'
import Marketadmin from './market_admin.js'
import EntityAdmin from './entity_admin.js'
import Entity from './entity.js'

export default [Superadmin,Globaladmin,Marketadmin,EntityAdmin,Entity]
